export default __webpack_public_path__ + "static/morph-thumb-bba4b4cfd4e0467cc88180803b081399.jpg";